import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import Typography from '@ui/Typography';
import Dialog from '@ui/Dialog';
import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
  InstapaperIcon,
} from 'react-share';

import {
  AiOutlineInstagram,
  AiOutlinePhone,
  AiOutlineMail,
  AiFillFacebook,
  AiFillLinkedin,
  AiFillInstagram,
} from 'react-icons/ai';
import { FaXTwitter } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import Link from 'next/navigation';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import { revalidatePage } from 'actions/server.actions';

const iconSize = 24;

function ContactInformation({ userProfile, handleClose, isPublic = false }) {
  const [open, setOpen] = useState(true);

  const contactFields = [
    {
      label: 'Email',
      value: userProfile.email,
      icon: <AiOutlineMail size={iconSize} />,
    },
    {
      label: 'Facebook',
      value: userProfile.facebookProfile,
      icon: <AiFillFacebook size={iconSize} />,
    },
    {
      label: 'LinkedIn',
      value: userProfile.linkedin_profile || userProfile.linkedinProfile,
      icon: <AiFillLinkedin size={iconSize} />,
    },
    {
      label: 'Twitter',
      value: userProfile.twitterProfile,
      icon: <FaXTwitter size={iconSize} />,
    },
    {
      label: 'Instagram',
      value: userProfile.instagramProfile,
      icon: <AiOutlineInstagram size={iconSize} />,
    },
    {
      label: 'Phone No',
      value: userProfile.phoneNumber,
      icon: <AiOutlinePhone size={iconSize} />,
    },
  ];

  const setIsOpen = useEditProfileStore((state) => state.setOpen);

  const renderLinks = (url, label) => {
    switch (label) {
      case 'Email':
        return (
          <a
            href={`mailto:${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full overflow-x-hidden break-words">
            {url}
          </a>
        ); // Use <a> for email links
      case 'Phone No':
        return (
          <a href="#" className="w-full overflow-x-hidden break-words">
            {url}
          </a>
        );
      default:
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full overflow-x-hidden break-words">
            {url}
          </a>
        );
    }
  };

  const handleEdit = () => {
    setIsOpen(true, userProfile, 'Contact Information');
    revalidatePage('/profile/me');
  };

  const handleDialogClose = () => {
    setOpen(!open);
    handleClose(!open);
  };

  const isPublicCheck = (label) => {
    return isPublic && ['Phone No', 'Email'].includes(label);
  };

  return (
    <Dialog
      isOpen={open}
      onClose={handleDialogClose}
      title={userProfile?.fullName}
      maxWidth="md">
      <div className="flex w-full flex-col items-center">
        <div className="flex w-full flex-row items-center justify-between">
          <Typography variant="h2" className="font-normal">
            Contact Info
          </Typography>
          <div>
            {!isPublic && (
              <IconButton onClick={handleEdit}>
                <MdEdit />
              </IconButton>
            )}
          </div>
        </div>
        {contactFields.map((field) =>
          field.value && !isPublicCheck(field.label) ? (
            <div
              key={field.label}
              className="my-2 flex w-full items-center justify-start gap-3 space-y-1">
              <div className="w-8 space-x-1 text-center">{field.icon}</div>
              <div>
                <div className="font-medium">{field.label}</div>
                <Typography
                  variant="h5"
                  color="primary"
                  className="w-full overflow-x-hidden hover:text-chips-primary-dark">
                  {renderLinks(field.value, field.label)}
                </Typography>
              </div>
            </div>
          ) : null,
        )}
      </div>
    </Dialog>
  );
}

export default ContactInformation;
